import { Nullable } from '../../types';

export const createHeadersForValue = (
  key: string,
  value: Nullable<string | number | undefined>,
): Record<string, string> => {
  if (value === undefined || value === null) {
    return {};
  }

  return {
    [key]: `${value}`,
  };
};
